import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { api, track } from "@/lib/api";
import { useSEO, breadcrumbSchema } from "@/lib/seo";

export default function FAQ() {
  const navigate = useNavigate();
  const [faqs, setFaqs] = useState([]);

  useSEO({
    title: "FAQ — Mashara Finance | Pricing, Trial, Security & Features",
    description: "Answers about Mashara Finance: pricing, free trial, setup, multi-center management, payroll, security, cancellation and support.",
    path: "/faq",
    jsonLd: [
      breadcrumbSchema([{ name: "Home", path: "/" }, { name: "FAQ", path: "/faq" }]),
      ...(faqs.length ? [{
        "@context": "https://schema.org", "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
      }] : []),
    ],
  });

  useEffect(() => {
    api.get("/cms/content").then((r) => setFaqs(r.data.faqs || [])).catch(() => {});
  }, []);

  return (
    <div data-testid="faq-page" className="py-16 sm:py-24">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-xs font-semibold uppercase tracking-widest text-emerald-700 mb-3">FAQ</p>
          <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight text-slate-900">Questions, Answered Honestly</h1>
        </div>
        <Accordion type="single" collapsible>
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`}>
              <AccordionTrigger data-testid={`faq-item-${i}`} className="text-left font-medium text-slate-900">{f.q}</AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
        <div className="mt-12 text-center rounded-2xl bg-slate-50 border border-slate-200 p-8">
          <h2 className="font-display font-bold text-xl text-slate-900">Still have questions?</h2>
          <div className="mt-4 flex flex-col sm:flex-row justify-center gap-3">
            <Button data-testid="faq-trial-button" onClick={() => { track("hero_cta_click", { location: "faq" }); navigate("/signup"); }}
              className="rounded-xl bg-emerald-700 hover:bg-emerald-800 text-white">Start Free Trial</Button>
            <Button data-testid="faq-demo-button" variant="outline" onClick={() => navigate("/demo")}
              className="rounded-xl border-slate-300 text-slate-700">Book a Demo</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
